export function truncateAddress(address: string, length: number): string {
  if (!address) {
    return ''
  }

  return `${address.substr(0, length)}...${address.substr(-length)}`
}
